<script setup lang="ts">
type Priority = "auto" | "high" | "low" | undefined;

defineProps({
  image: {
    type: Object,
    required: true
  },
  alt: {
    type: String,
    default: ''
  },
  loading: {
    type: String as () => "eager" | "lazy" | undefined,
    default: 'eager'
  },
  fetchPriority: {
    type: String as () => Priority,
    default: 'auto'
  },
  imgClass: {
    type: String,
    default: ''
  }
})

// consider attribute "preview" to open lightbox with maximized image
</script>

<template>
  <picture>
    <template
      v-for="(srcSet, format) in image.sources"
      :key="format"
    >
      <source
        :type="`image/${format}`"
        :srcset="srcSet"
      >
    </template>

    <img
      :src="image.img.src"
      :width="image.img.w"
      :height="image.img.h"
      :alt="alt"
      :loading="loading"
      :fetchpriority="fetchPriority"
      :class="imgClass"
      decoding="async"
    >
  </picture>
</template>
